//物品类型
export enum pawnShopObjTypeE{
    //普通物品
    normal
}
//物品品质
export enum pawnShopObjQualityE{
    broken,
    blemish,
    intact,
    best
}

//可以买卖的物品
export interface pawnShopGameObjI{
    //物品id
    id:string,
    //物品名字
    name:string,
    //预制体名字
    prefabPath:string,
    //物品类型
    type:pawnShopObjTypeE,
    //出现权重
    weight:number,
    //物品品质
    quality:pawnShopObjQualityE,
    //买的时候可以寻找的缺点
    buyFindObjs:string[],
    //是否可以修复
    canFix?:boolean,
    //价格
    price:number,
    //绑定的背包物品Id
    bindBackId:number
}
//可以寻找的东西
export interface pawnShopGameBlemishI{
    id:string,
    //名字
    name:string,
    //影响的价格 如果小于0且大于-1 则按比例降价 如果小于1且大于0则按比例加钱 如果小于-1则降固定数量的钱 如果大于1则加固定的钱  如果影响的价格的数量大于1个则从区间中随机取
    influencePrice:number,
    //找到时的描述 找到时顾客会说的话
    findExplain:string[],
}
//出场的人
export interface pawnShopPeopleI{
    //人的id
    id:string,
    //人的名字
    name:string,
    //人的显示图片
    spPath:string
}

export interface pawnShopBackpackObjI{
    id:string,
    //购买时的价格
    buyPrice:number,
    //购买的日期 按照游戏中的时间算
    buyTime:number,
    //可修复次数
    canFixCount:number,
    //已修复次数
    fixCount:number
}

//鉴宝物品map
export interface pawnShopGameObjMap{
    [id:string]: pawnShopGameObjI;
}

//鉴宝背包物品map
export interface pawnShopBackpackMap{
    [id:string]:pawnShopBackpackObjI[];
}

//鉴宝数据
export interface pawnShopGameDataI{
    backpack:pawnShopBackpackMap;
}

//瑕疵map
export interface pawnShopGameBlemishMap{
    [id:string]:pawnShopGameBlemishI;
}

//修复时的数据
export interface pawnShopFixGameSelectDataI{
    obj:pawnShopBackpackObjI,
    index:number,
    renderIndex?:number
}
